import React from 'react';
import styles from 'pages/GroupSettings.module.css';
import globalStyles from 'Global.module.css';
import { Link, useParams } from 'react-router';
import { useQuery } from '@apollo/client/react';
import { GetPendingMembersDocument } from 'graphql/queries.generated';
import Image from 'components/Image';
import { ImageOwnerType, ImageSize } from 'app-constants';

const GroupSettings: React.FC = () => {
    const { organizationId } = useParams<{ organizationId: string }>();

    const { data, loading, error } = useQuery(GetPendingMembersDocument, {
        variables: { organizationId: organizationId! },
        skip: !organizationId,
    });

  return (
      <div className={globalStyles.shadowBox + ' ' + styles.groupSettings}>
      <h1>Group Settings</h1>
          <ul>
              <li><Link to={`/groups/${organizationId}/edit`}>Edit Group Details</Link></li>
              <li><Link to={`/groups/${organizationId}/member-settings`}>New Member Settings</Link></li>
          </ul>

          <h2>Applications</h2>
          {loading && <p>Loading applications...</p>}
          {error && <p>Error loading applications: {error.message}</p>}
          {data && data.pendingMembers && data.pendingMembers.length === 0 && (
              <p>No pending applications.</p>
          )}
          {data && data.pendingMembers && data.pendingMembers.length > 0 && (
              <div className={styles.applications}>
                  {data.pendingMembers.map((member: { organizationMemberId: string; mainProfile: { username: string; imageId: string | null } }) => (
                      <Link
                          key={member.organizationMemberId}
                          to={`/groups/${organizationId}/applications/${member.organizationMemberId}`}
                          className={styles.applicationCard}
                      >
                          <Image
                              imageOwnerType={ImageOwnerType.Person}
                              imageSize={ImageSize.Thumbnail}
                              imageId={member.mainProfile.imageId}
                              className={globalStyles.profileThumbnail}
                          />
                          <span>{member.mainProfile.username}</span>
                      </Link>
                  ))}
              </div>
          )}
    </div>
  );
};

export default GroupSettings;
